import { render, staticRenderFns } from "./JoeyLogo.vue?vue&type=template&id=0b953e10"
import script from "./JoeyLogo.vue?vue&type=script&lang=ts"
export * from "./JoeyLogo.vue?vue&type=script&lang=ts"
import style0 from "./JoeyLogo.vue?vue&type=style&index=0&id=0b953e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports